var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderinline = function SvgOrderinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.406 8.003-6.7-3.876M16.811 12.998V6.943a1.51 1.51 0 0 0-.757-1.309l-5.297-3.027a1.51 1.51 0 0 0-1.514 0L3.946 5.634a1.51 1.51 0 0 0-.757 1.31v6.054a1.51 1.51 0 0 0 .757 1.309l5.297 3.027a1.51 1.51 0 0 0 1.514 0l5.297-3.027a1.51 1.51 0 0 0 .757-1.31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.475 6.232 10 9.978 3.507 6.222M10 17v-7"
  })));
};
export default SvgOrderinline;